var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 11.5523 0.447715 12 1 12H13C13.5523 12 14 11.5523 14 11C14 10.4477 13.5523 10 13 10H1C0.447715 10 0 10.4477 0 11Z",
    fill: "#091526",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 5.44772 0.447715 5 1 5H8C8.55228 5 9 5.44772 9 6C9 6.55228 8.55228 7 8 7H1C0.447715 7 0 6.55228 0 6Z",
    fill: "#091526",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0C0.447715 0 0 0.447715 0 1C0 1.55229 0.447715 2 1 2H4C4.55228 2 5 1.55229 5 1C5 0.447715 4.55228 0 4 0H1Z",
    fill: "#091526",
    fillOpacity: 0.35
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortOrder);
export default __webpack_public_path__ + "static/media/SortOrder.581472335fd16f0bdc9213e42dc99801.svg";
export { ForwardRef as ReactComponent };